import { IconButton, Modal, useModalContext, VisuallyHidden } from '@coop/components';
import { CloseIcon } from '@coop/icons';
import classnames from 'classnames';

import CloudinaryImage from '../../../../../common/components/atoms/CloudinaryImage';
import useModal from '../../../../../common/hooks/useModal';
import { ZoomProductImageType } from '../../../../../common/store/structureDefinitions/modalState';
import { ga4ProductsTracking } from '../../../../../common/tracking/ga4/products';
import ProductImage from './ProductImage';
import styles from './ProductImage.module.scss';

const ModalContent = (props: { onModalClose: () => void; name: string; imageUrl?: string }) => {
    const context = useModalContext();

    return (
        <>
            <VisuallyHidden>
                <div aria-hidden id={context?.headerId}>
                    {props.name} förstorad bild
                </div>
            </VisuallyHidden>
            <div className={classnames(styles.CloseButtonDiv, 'u-posAbsolute')}>
                <IconButton
                    icon={CloseIcon}
                    label="Stäng"
                    theme="soft"
                    size={40}
                    onClick={props.onModalClose}
                />
            </div>
            <picture className={classnames(styles.ImageContainer, 'u-bgWhite', 'u-paddingAlg')}>
                <CloudinaryImage
                    url={props.imageUrl}
                    cssClass={styles.Image}
                    name={props.name}
                    transform="e_sharpen,f_auto,fl_clip,fl_progressive,q_90,c_lpad,g_center,h_660,w_660"
                />
            </picture>
        </>
    );
};

const ProductImageTrigger = (props: { imageUrl?: string; name: string }) => {
    const { isOpen, close, open } = useModal(ZoomProductImageType.zoomProductImage);

    const closeModal = () => {
        close();
        ga4ProductsTracking.zoomImage(false);
    };
    const openModalClick = () => {
        open();
        ga4ProductsTracking.zoomImage(true);
    };

    return (
        <>
            <ProductImage
                onImageClick={openModalClick}
                onZoomClick={openModalClick}
                imageUrl={props.imageUrl}
                name={props.name}
            />
            <Modal isOpen={isOpen} close={closeModal} additionalClasses={styles.ZoomModal}>
                <ModalContent
                    onModalClose={closeModal}
                    name={props.name}
                    imageUrl={props.imageUrl}
                />
            </Modal>
        </>
    );
};

export default ProductImageTrigger;
